export default __webpack_public_path__ + "static/procurot-51833cbe3c5ef1714c3be752e863f730.webp";